var map = {
	"./afrikaans.json": "88b3",
	"./albanian.json": "3917",
	"./arabic.json": "de85",
	"./armenian.json": "f7a1",
	"./azerbaijani.json": "43dc",
	"./basque.json": "d22d",
	"./belarusian.json": "aa51",
	"./bengali.json": "9bbf",
	"./bosnian.json": "b179",
	"./bulgarian.json": "1222",
	"./catalan.json": "f0c3",
	"./cebuano.json": "c5b2",
	"./chichewa.json": "65d2",
	"./chinese.json": "7a75",
	"./corsican.json": "7fb0",
	"./croatian.json": "451a",
	"./czech.json": "941a",
	"./danish.json": "727f",
	"./dutch.json": "cc26",
	"./english.json": "af0f",
	"./esperanto.json": "7ea7",
	"./estonian.json": "5ceb",
	"./filipino.json": "841d",
	"./finnish.json": "f691",
	"./french.json": "5def",
	"./frisian.json": "d62d",
	"./galician.json": "f227",
	"./georgian.json": "8f5b",
	"./german.json": "1b2c",
	"./greek.json": "0ad9",
	"./gujarati.json": "2e53",
	"./haitian.json": "2947",
	"./hausa.json": "1f25",
	"./hawaiian.json": "8f84",
	"./hebrew.json": "f0c5",
	"./hindi.json": "3adc",
	"./hmong.json": "6255",
	"./hungarian.json": "4eaf",
	"./icelandic.json": "d1f0",
	"./igbo.json": "fc69",
	"./indonesian.json": "4e9b",
	"./irish.json": "471a",
	"./italian.json": "34c9",
	"./japanese.json": "9944",
	"./javanese.json": "52e7",
	"./kannada.json": "b5a0",
	"./kazakh.json": "fa34",
	"./khmer.json": "9cf6",
	"./korean.json": "f0d7",
	"./kurdish.json": "8f51",
	"./kyrgyz.json": "4dc9",
	"./lao.json": "6e22",
	"./latin.json": "3a27",
	"./latvian.json": "760b",
	"./lithuanian.json": "44e9",
	"./luxembourgish.json": "6f22",
	"./macedonian.json": "4256",
	"./malagasy.json": "9442",
	"./malayalam.json": "5484",
	"./malaysian.json": "48ef",
	"./maltese.json": "d1f5",
	"./maori.json": "63bb",
	"./marathi.json": "47c8",
	"./mongolian.json": "bf0f",
	"./myanmar.json": "fd86",
	"./nepali.json": "3eeb",
	"./norwegian.json": "9c7b",
	"./pashto.json": "746b",
	"./persian.json": "30f5",
	"./polish.json": "1c79",
	"./portuguese.json": "cc02",
	"./punjabi.json": "5b53",
	"./romanian.json": "5f6c",
	"./russian.json": "4ebb",
	"./serbian.json": "a5e5",
	"./sesotho.json": "46eb",
	"./shona.json": "bd31",
	"./sindhi.json": "1b76",
	"./sinhala.json": "4862",
	"./slovak.json": "5954",
	"./slovenian.json": "645b",
	"./somali.json": "f9b4",
	"./spanish.json": "1989",
	"./sundanese.json": "2284",
	"./swahili.json": "146c",
	"./swedish.json": "b4ee",
	"./tajik.json": "79c9",
	"./tamil.json": "24c5",
	"./telugu.json": "7d18",
	"./thai.json": "b6fb",
	"./turkish.json": "d2d5",
	"./ukrainian.json": "2f2d",
	"./urdu.json": "4b0e",
	"./uzbek.json": "2745",
	"./vietnamese.json": "bb4a",
	"./welsh.json": "a6c1",
	"./xhosa.json": "012e",
	"./yiddish.json": "8229"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a67";